export const getCompress = (watchfaceAst: Ast) => {
  const compress = watchfaceAst.attrsMap.compressMethod;
  const compressName = compress_list[compress] ?? '不压缩';
  return [compressName];
};

const compress_list: any = {
  none: '不压缩',
  RLEReversed: 'RLE标准压缩方式',
  RLE: 'RLE-L67特别版',
  ezip: 'EZIP- N65AB特别版本'
};
